const ALL_LEGACY_FIND_CATEGORIES = ["see", "eat", "drink", "do", "shop", "relax"];
const LEGACY_FIND_CATEGORY_LABEL_BY_KEY = {
  see: "see",
  eat: "eat",
  drink: "drink",
  do: "do",
  shop: "shop",
  relax: "relax",
};

function normalizeCapsuleType(value = "") {
  return String(value || "").trim().toLowerCase().replace(/[-_\s]/g, "");
}

function normalizeCategories(categories = []) {
  return Array.isArray(categories)
    ? Array.from(
        new Set(
          categories
            .map((category) => String(category || "").trim().toLowerCase())
            .filter(Boolean)
        )
      )
    : [];
}

function isDraftCapsule(capsule = {}) {
  return (
    capsule?.isDraft === true ||
    String(capsule?.status || "").trim().toLowerCase() === "draft" ||
    String(capsule?.lifecycleStatus || "").trim().toLowerCase() === "draft"
  );
}

export function filterLegacyFindCapsules(capsules = [], categories = []) {
  const selectedCategories = normalizeCategories(categories);
  const shouldFilterByCategory =
    selectedCategories.length > 0 &&
    selectedCategories.length < ALL_LEGACY_FIND_CATEGORIES.length;
  const selectedSet = new Set(selectedCategories);

  return (Array.isArray(capsules) ? capsules : []).filter((capsule) => {
    if (isDraftCapsule(capsule)) return false;
    if (capsule?.adminStarred === true || capsule?.insider === true) return false;
    if (capsule?.seeded !== true) return false;
    if (normalizeCapsuleType(capsule?.capsuleType) !== "public") return false;

    const seedType = String(capsule?.seedType || "").trim().toLowerCase();
    if (!seedType) return false;
    if (!shouldFilterByCategory) return ALL_LEGACY_FIND_CATEGORIES.includes(seedType);
    return selectedSet.has(seedType);
  });
}

export function isLegacyFindNoResults(result = {}) {
  if (result?.reason === "no_uncover_results") return true;
  if (Object.prototype.hasOwnProperty.call(result || {}, "visibleCount")) {
    return Number(result?.visibleCount || 0) === 0;
  }
  return false;
}

export function buildLegacyFindNoResultsMessage(categories = []) {
  const selectedCategories = normalizeCategories(categories);
  if (selectedCategories.length === 1) {
    const selectedKey = selectedCategories[0];
    const selectedLabel = LEGACY_FIND_CATEGORY_LABEL_BY_KEY[selectedKey] || "selected";
    return `No ${selectedLabel.toLowerCase()} capsules found nearby yet. Try another type.`;
  }
  return "No matching capsules found nearby yet. Try another type.";
}
